import { OOCheck } from "./oo-check";

export class AddressModel {
	street: string;
	suiteApt: string;
	city: string;
	state: string;
	zipCode: string;
	latitude: number;
	longitude: number;
	formattedAddress: string;

	public constructor(init?: Partial<AddressModel>) {
		Object.assign(this, init);
	}

	static addressToCheck(a: AddressModel, check: OOCheck): OOCheck {
		check.shipping.address1 = a.street;
		check.shipping.address2 = a.suiteApt;
		check.shipping.city = a.city;
		check.shipping.state = a.state;
		check.shipping.postalCode = a.zipCode;

		check.billing.address1 = a.street;
		check.billing.address2 = a.suiteApt;
		check.billing.city = a.city;
		check.billing.state = a.state;
		check.billing.postalCode = a.zipCode;

		return check;
	}
}
